import React from 'react';
import Big from 'big.js';
import { Typography } from '@utex/ui-kit';
import { useExchangeRate } from '../../../hooks/exchangeRate';

interface Props {
  amount: number;
}

export const USDEquivalent: React.FC<Props> = ({ amount }) => {
  const { RUBUSD } = useExchangeRate();

  if (!RUBUSD) {
    return null;
  }

  return (
    <Typography.Text size="XL" view="hint">
      ≈ {new Big(RUBUSD).mul(new Big(amount)).round(2).valueOf()} $
    </Typography.Text>
  );
};
